import styled from 'styled-components';
import { Flex } from 'antd';

export const PageTitleStyled = styled.div`
  margin-bottom: 20px;
`;

export const BackHeaderStyled = styled(Flex)`
  margin-bottom: 12px;
`;

export const StatsBarStyled = styled(Flex)`
  background: ${p => p.theme?.colors?.white ?? '#fff'};
  border: 1px solid ${p => p.theme?.colors?.border ?? '#D8DAE5'};
  border-radius: 12px;
  padding: 12px 16px;
  margin-bottom: 24px;
`;

export const CategorySectionStyled = styled.div`
  background: ${p => p.theme?.colors?.white ?? '#fff'};
  border: 1px solid ${p => p.theme?.colors?.border ?? '#D8DAE5'};
  border-radius: 12px;
  padding: 16px 20px;
  margin-bottom: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;

  & .ant-divider {
    margin: 0;
  }

  &:last-child {
    margin-bottom: 0;
  }
`;

export const AddRowStyled = styled(Flex)`
  margin: 12px 0;
`;
